"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCode = void 0;
async function setCode(client, _ref) {
  let {
    address,
    bytecode
  } = _ref;
  await client.request({
    method: "".concat(client.mode, "_setCode"),
    params: [address, bytecode]
  });
}
exports.setCode = setCode;
//# sourceMappingURL=setCode.js.map